<script lang="ts">
  import {
    CheckList,
    Header,
    List,
    Paragraph,
    Raw,
    Code,
    Quote,
    Image,
    Warning,
    Delimiter
  } from '../editorjs';
  import type { EditorJs } from 'query-strapi-v4';
  export let editor: string;
  const editorjs = JSON.parse(editor) as EditorJs.Editor;
</script>

{#each editorjs.blocks as editorBlock (editorBlock.id)}
  <!-- {JSON.stringify(editorBlock, null, 2)} -->
  {#if editorBlock.type === 'paragraph'}
    <Paragraph block={editorBlock} />
  {/if}
  {#if editorBlock.type === 'raw'}
    <Raw block={editorBlock} />
  {/if}
  {#if editorBlock.type === 'code'}
    <Code block={editorBlock} />
  {/if}
  {#if editorBlock.type === 'header'}
    <Header block={editorBlock} />
  {/if}
  {#if editorBlock.type === 'quote'}
    <Quote block={editorBlock} />
  {/if}
  {#if editorBlock.type === 'list'}
    <List block={editorBlock} />
  {/if}
  {#if editorBlock.type === 'checklist'}
    <CheckList block={editorBlock} />
  {/if}
  {#if editorBlock.type === 'warning'}
    <Warning block={editorBlock} />
  {/if}
  {#if editorBlock.type === 'delimiter'}
    <Delimiter />
  {/if}
  {#if editorBlock.type === 'image'}
    <Image block={editorBlock} />
    <!-- {JSON.stringify(editorBlock.data, null, 2)} -->
    <!-- <CheckList block={editorBlock} /> -->
  {/if}
{/each}
